import React from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg'

const strengths = [
    '20+ years of combined IT industry experience',
    'Highly skilled consultants, engineers and delivery specialists',
    'A Teams Asset Sdn Bhd group company',
];

const CompanyIntro = () => {
    return (
        <section className="company_intro_section bg-light">
            <div className="container">
                <div className="company_intro_panel">
                    <div className="row align-items-center justify-content-lg-between">
                        <div className="col-lg-6">
                            <div className="heading_block mb-lg-0">
                                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                    About Krit Cloud Platforms
                                </div>
                                <h2 className="heading_text mb-0">
                                    Krit is a <mark>Teams Asset Sdn Bhd</mark> Group Company
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <p className="company_intro_text">
                                Krit Cloud Platforms Sdn Bhd is a Teams Asset Sdn Bhd group company focused on practical IT services, cloud platforms, software development, cybersecurity, data, automation and enterprise technology delivery.
                            </p>
                            <p className="company_intro_text mb-0">
                                Our team brings more than 20 years of combined IT industry experience, helping businesses modernize systems, improve operations and build reliable technology foundations for long-term growth.
                            </p>
                        </div>
                    </div>
                    <div className="company_intro_strengths">
                        {strengths.map((strength) => (
                            <div className="company_intro_strength" key={strength}>
                                <i className="fa-regular fa-circle-check"></i>
                                <span>{strength}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CompanyIntro;
